import { isWeb } from "@memorang/helpers/platform";
import { Portal } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDevice } from "../useDevice";
import ProfileIcon from "./ChatUI/ProfileIcon";
import { FAB } from "./FAB";

type Props = {
	icon: string;
	label: string;
	onPress?: () => void;
};

export const AiFab = ({ icon, label, onPress }: Props) => {
	const insets = useSafeAreaInsets();
	const { isMobile } = useDevice();

	const bottomBarHeight = isMobile ? (isWeb ? 96 : 56) : 104;
	return (
		<Portal>
			<FAB
				icon={(_props) => <ProfileIcon uri={icon} />}
				label={label}
				style={{
					position: "absolute",
					bottom: insets.bottom + bottomBarHeight + 16,
					right: isMobile ? 16 : 24,
				}}
				onPress={onPress}
			/>
		</Portal>
	);
};
